import { useCallback, useState } from "react";

import { FilterService } from "./FilterService";

export const useInMemorySearch = () => {
    const [filterService, updateFilterService] = useState(new FilterService(""));

    const setSearchValue = useCallback((newSearchValue: string) => {
        updateFilterService(new FilterService(newSearchValue));
    }, []);

    return { searchService: filterService, setSearchValue };
};
